import Loading from '../../../Common/Loading';
import { useStratifiedProductionChartsDataContext } from './hooks/useStratifiedProductionChartsDataContext';
import { AnnualEvolutionServices } from './AnnualEvolutionServices';
import { MonthlyEvolutionServices } from './MonthlyEvolutionServices';
import { ServicesByAge } from './ServicesByAge';
import { ServicesBySex } from './ServicesBySex';
import { Indicators } from './Indicators';

export const Charts = () => {
    const { isLoading } = useStratifiedProductionChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <AnnualEvolutionServices />
                <ServicesBySex />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ServicesByAge />
                <MonthlyEvolutionServices />
            </div>
        </>
    );
};
